/**
 * 메인 화면
 */
import React, { Component } from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserTie } from '@fortawesome/free-solid-svg-icons';

import { Link } from "react-router-dom";
import { udfAutoLogin, AlertModal } from '../common/common';
import loader from '../imgs/ajax-loader.gif';
import logoBi from '../logo-bi.png';

class MainCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT' && data.STD_CD !== '') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'STDT' && data.STD_CD === '') {
        this.props.history.push('/joinStdt');
      } else if (data !== null && data.userSe === 'USR') {
        this.props.history.push('/menuList');
      }
    });
  }

  render() {
    const userGuBtnGrp =
      <main className="App-header">
        <Container style={{ maxWidth: '340px', textAlign: 'center' }}>
          <img src={logoBi} alt="스쿨라이프" style={{ width: "90%", marginBottom: '1rem' }} />
          <Row>
            <Col className='p-0'>
              <Link to="/login/S">
                <Card className="btn-school-life shadow" style={{ padding: '1rem', borderRadius: '50%', width: '150px', height: '150px', margin: '0 auto' }} >
                  <Card.Body style={{ color: '#fff', fontWeight: 'bold', padding: '1.2rem 0' }}>
                    <FontAwesomeIcon icon={faUser} style={{ fontSize: '3rem' }} /><div className="mt-2">학생 로그인</div>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
            <Col className='p-0'>
              <Link to="/login/T">
                <Card className="btn-school-life shadow" style={{ padding: '1rem', borderRadius: '50%', width: '150px', height: '150px', margin: '0 auto' }} >
                  <Card.Body style={{ color: '#fff', fontWeight: 'bold', padding: '1.2rem 0' }}>
                    <FontAwesomeIcon icon={faUserTie} style={{ fontSize: '3rem' }} /><div className="mt-2">교사 로그인</div>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          </Row>
          <Row style={{ marginTop: '2rem' }}>
            <Col className="text-nowrap text-left"><Link to="/Terms">이용약관</Link></Col>
            <Col className="text-nowrap"><Link to="/Private">개인정보처리방침</Link></Col>
            <Col className="text-nowrap text-right"><Link to="/JoinStdt">회원가입</Link></Col>
          </Row>
          <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>
            Copyright(c) IDPRO Corp. All rights reserved.<br />
            고객센터 <a data-rel="external" href="tel:070-8853-8886">070-8853-8886</a> /&nbsp;
            <a data-rel="external" href="mailto:help@idpro.kr">help@idpro.kr</a>
            <br />월~금 오전9시~오후6시 (점심시간 정오~오후1시)
          </p>
        </Container>
      </main>;

    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        <div id="menuBg" className="wrap-loading d-none"></div>
        <div className="wrap-loading">
          <img src={loader} alt="로딩 이미지" />
        </div>

        {userGuBtnGrp}
      </>
    );
  }
}

export default MainCmp;